module.exports = __webpack_public_path__ + "img/author_thumbnail-600x450.7b24add5.jpg";